// DrmPanel.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import DrmPanelTestSection from '../component/DrmPanelTestSection.jsx';
import ResponsiveInfoButton from '../component/ResponsiveInfoButton.jsx';

import LinkSubstring from '../container/LinkSubstring.js';

import { drmRulesetTestStatus } from '../resource/drmConstants.js';
import { getIsChinaPartner } from '../resource/partner.js';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import { textColor, color } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';

import {
  StyledModal,
  Header,
  BackButton,
  ActionButton,
  Title,
  Body,
  Section,
  SectionBody,
} from '../style/SettingModal.js';
import BackIconSource from '../../img/ic_topbar_back.svg';
import { ButtonId } from '../resource/mixpanel.js';

export const DrmPanel = ({
  drmTestStatus = null,
  messageId = null,
  drmTestAtUnixTimestamp = null,
  goBack = () => null,
  recheckDrmCapability = () => null,
  toggleModal = () => null,
  swagHelpArticlesUrl = '',
}) => {
  const { t } = useTranslation();
  const isTesting = drmRulesetTestStatus.TESTING === drmTestStatus;
  return (
    <StyledDrmPanel>
      <Header>
        <BackButton onClick={goBack}>
          <img src={BackIconSource.src || BackIconSource} alt="go back" />
        </BackButton>
        <Title>DRM</Title>
        <ActionButton
          data-element_id={ButtonId.All.ButtonCheck}
          onClick={recheckDrmCapability}
          disabled={isTesting}
        >
          {t('general_check', {
            ns: TranslationNamespace.SETTINGS,
          })}
        </ActionButton>
      </Header>
      <Body>
        <Section>
          <SectionBody>
            <DrmNotSupportDescription>
              <LinkSubstring>
                {getIsChinaPartner()
                  ? t('alert_device_not_supported', {
                      ns: TranslationNamespace.SETTINGS,
                    })
                  : t('alert_webapp_not_supproted', {
                      ns: TranslationNamespace.SETTINGS,
                    })}
              </LinkSubstring>
              <StyledFAQLink
                articleUrl={swagHelpArticlesUrl}
                modalId="IframeModal"
                modalHeaderTitle="device_support_instructions"
                toggleModal={toggleModal}
                trackingModalIdelementId={ButtonId.All.ButtonInformation}
                trackingPayload={{
                  'article.url': swagHelpArticlesUrl,
                }}
              >
                {t('device_support_instructions', {
                  ns: TranslationNamespace.GENERAL,
                })}
              </StyledFAQLink>
            </DrmNotSupportDescription>
          </SectionBody>
        </Section>
        <DrmPanelTestSection
          drmTestAtUnixTimestamp={drmTestAtUnixTimestamp}
          messageId={messageId}
        />
      </Body>
    </StyledDrmPanel>
  );
};

DrmPanel.propTypes = {
  drmTestStatus: PropTypes.string,
  messageId: PropTypes.string,
  drmTestAtUnixTimestamp: PropTypes.number,
  goBack: PropTypes.func,
  recheckDrmCapability: PropTypes.func,
  toggleModal: PropTypes.func,
  swagHelpArticlesUrl: PropTypes.string,
};

const StyledDrmPanel = styled(StyledModal)``;

const DrmNotSupportDescription = styled.div`
  padding: 16px;
  color: ${textColor.white};
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
`;

const StyledFAQLink = styled(ResponsiveInfoButton)`
  ${ResetButtonStyle};
  color: ${color.tealBlue};
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  margin-top: 16px;
`;

export default DrmPanel;
